export default "__VITE_ASSET__D_XNN6C0__"